import { QUESTION_TYPE } from '../../../../constants/questionTypes';
import type { TextAndMediaQuestion } from '../../../../types/index';
import type { ApiQuestion } from '../../../../internalTypes';
import type { ResolvedQuestionShell } from '../shared/resolveQuestionShell';
import { buildMediaConfig } from './buildMediaConfig';

export function mapTextAndMediaQuestion(
  raw: ApiQuestion,
  shell: ResolvedQuestionShell
): TextAndMediaQuestion {
  const media = buildMediaConfig(raw);
  const { containerMedia: _containerMedia, ...shellFields } = shell;

  let questionText = shell.questionText;
  if (Array.isArray(raw.answerDetails)) {
    const headerDetail = raw.answerDetails.find(
      d => d.additional?.textAndMediaFieldType === 'HEADER'
    );
    if (headerDetail?.answerText) {
      questionText = headerDetail.answerText;
    }
  }

  const hasMedia = Object.keys(media).length > 0;

  return {
    ...shellFields,
    questionText,
    type: QUESTION_TYPE.TEXT_AND_MEDIA,
    ...(hasMedia ? { media } : {}),
  };
}
